import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../ui/theme/colors';

// MUI X Tree View v9 removed the Mui-expanded / Mui-selected / Mui-focused state
// classes; state now lives in data-* attributes on the content element. All
// state styling below therefore targets the content slot directly.
export const useSettingsTreeNodeStyles = makeStyles((theme) => ({
  content: {
    borderRadius: theme.spacing(1),
    // x-tree-view v7 added vertical padding to Content (v6 was '0 8px')
    paddingTop: 0,
    paddingBottom: 0,
    // Neutralise the default hover / focus / selected / expanded backgrounds.
    '&:hover, &:focus, &[data-focused], &[data-expanded], &[data-selected]': {
      backgroundColor: 'transparent !important'
    },
    '&[data-selected]': {
      border: `1px solid ${theme.palette.primary.main}`
    },
    '&:hover $label, &:focus $label, &[data-focused] $label, &[data-expanded] $label, &[data-selected] $label': {
      backgroundColor: 'transparent !important'
    }
  },
  label: {},
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0)
  },
  labelIcon: {
    maxHeight: 18,
    maxWidth: 18,
    marginRight: theme.spacing(1),
    color: Colors.midGray
  }
}));
